import React from 'react';
import { MatchStatus, TemplateStatus, TemplateSummary, TemplateType } from '../../../services/formTemplate.service';

export const TemplateTypeLabel: Record<TemplateType, string> = {
  BOOKLET: 'Account opening booklet',
  CKYC: 'CKYC form',
  FATCA: 'FATCA / CRS form',
  OTHER: 'Other form',
};

const STATUS: Record<TemplateStatus, { label: string; cls: string }> = {
  UPLOADED: { label: 'Uploaded', cls: 'bg-light text-dark' },
  DISCOVERED: { label: 'Discovered', cls: 'bg-primary-subtle text-primary' },
  FLAT: { label: 'Not fillable', cls: 'bg-danger-subtle text-danger' },
  MAPPING_IN_PROGRESS: { label: 'Mapping', cls: 'bg-warning-subtle text-warning-emphasis' },
  VALIDATED: { label: 'Validated', cls: 'bg-info-subtle text-info-emphasis' },
  ACTIVE: { label: 'Active — live', cls: 'bg-success text-white' },
  RETIRED: { label: 'Deactivated', cls: 'bg-light text-muted' },
};

export const StatusBadge: React.FC<{ status: TemplateStatus }> = ({ status }) => (
  <span className={`badge ${STATUS[status].cls}`}>{STATUS[status].label}</span>
);

const MATCH: Record<MatchStatus, { label: string; cls: string }> = {
  AUTO_MATCHED: { label: 'Auto-matched', cls: 'bg-primary-subtle text-primary' },
  FLAGGED: { label: 'Flagged', cls: 'bg-danger-subtle text-danger' },
  CONFIRMED: { label: 'Confirmed', cls: 'bg-success-subtle text-success' },
  NOT_APPLICABLE: { label: 'Not applicable', cls: 'bg-light text-muted' },
};

export const MatchBadge: React.FC<{ status: MatchStatus }> = ({ status }) => (
  <span className={`badge ${MATCH[status].cls}`}>{MATCH[status].label}</span>
);

/** Compact confirmed / auto / flagged / n-a counters used in the list and the mapping header. */
export const MappingCounts: React.FC<{ t: TemplateSummary; verbose?: boolean }> = ({ t, verbose }) => (
  <span className="text-nowrap">
    <span className="badge bg-success-subtle text-success me-1" title="Confirmed">{t.confirmed}{verbose ? ' confirmed' : ''}</span>
    <span className="badge bg-primary-subtle text-primary me-1" title="Auto-matched, awaiting confirmation">{t.autoMatched}{verbose ? ' auto-matched' : ''}</span>
    <span className="badge bg-danger-subtle text-danger me-1" title="Flagged — needs mapping">{t.flagged}{verbose ? ' flagged' : ''}</span>
    <span className="badge bg-light text-muted" title="Not applicable">{t.notApplicable}{verbose ? ' not applicable' : ''}</span>
  </span>
);
